export default __webpack_public_path__ + "static/media/Mark-4-HUD-07.404109bc.jpg";